<template>
  <div>
    <Modal v-model="visible" width="700px" title="发起签署合同" :footer-hide="true" :mask-closable="false" class="my-modal top" :closable="!loading">
      <div v-if="!loading">
        <Form ref="form" :model="formData" :label-width="130" class="page-form" v-if="visible">
          <FormItem label="入职合同签署时间" prop="entrySignDate" :rules="$units.formRule.required('请选择')" class="full" key="entrySignDate">
            <DatePicker
              type="date"
              transfer
              format="yyyy-MM-dd"
              placeholder="选择日期"
              @on-change="formData.entrySignDate = $event"
              :value="formData.entrySignDate"
            ></DatePicker>
          </FormItem>
        </Form>
        <div class="ivu-modal-footer">
          <Button type="text" @click="visible = false">取消</Button>
          <Button type="primary" @click="submit">下一步</Button>
        </div>
      </div>

      <Col class="demo-spin-col" span="24" v-else>
        <Spin fix>
          <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
          <div class="text">文件正在生成中，请耐心等待...</div>
        </Spin>
      </Col>
    </Modal>
    <!-- 预览合同 -->
    <contract-preview-modal ref="contractPreviewModal" @success="$emit('success')" @cancel="visible = true"></contract-preview-modal>
  </div>
</template>

<script>
import uploadNew from '@/components/commons/uploadNew';
import contractPreviewModal from './contractPreviewModal';
export default {
  components: {
    uploadNew,
    contractPreviewModal,
  },
  data() {
    return {
      data: {},
      visible: false,
      loading: false,
      orgUserList: [],
      formData: {}
    };
  },
  methods: {
    open(data = {}) {
      this.formData = JSON.parse(JSON.stringify(data));
      this.data = JSON.parse(JSON.stringify(data));
      this.$set(this.formData, 'entrySignDate', '');
      this.visible = true;
      this.loading = false;
    },
    submit() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        this.nextStep();
      });
    },
    nextStep() {
      this.loading = true;
      this.$http({
        url: '/buz/userDimission/createDimissionSignFile',
        type: 'POST',
        forced: true,
        data: {
          agentId: this.formData.id,
          entrySignDate: this.formData.entrySignDate
        }
      }).then(res => {
        if (res.httpCode == 500002) {
          this.$Modal.error({
            title: '提示',
            width: 700,
            closable: true,
            content: `<p style='white-space: pre-wrap;'>${JSON.parse(res.msg).msg || res.msg}<p>`
          });
          this.loading = false;
        } else if (res.httpCode != 5002 && res.httpCode != 1) {
          this.$Modal.error({
            title: '提示',
            width: 700,
            closable: true,
            content: `<p style='white-space: pre-wrap;'>${res.msg}<p>`
          });
          this.loading = false;
        } else {
          this.loading = false;
          this.visible = false;
          this.$refs.contractPreviewModal.open(this.formData, res.data);
        }
        this.visible = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/deep/.ivu-select {
  flex: 0 0 41.5%;
}

.flex {
  /deep/.ivu-form-item-content {
    display: flex;
  }

  .ivu-input-wrapper {
    flex: 0 0 41.5%;
  }
}

.breed-name {
  margin-left: 10px;
}

.full {
  flex: 1;
  .ivu-input-wrapper {
    flex: 1;
  }
}
.iconwenhao {
  cursor: pointer;
}
.demo-spin-col {
  height: 50px;
  margin-top: 50px;
  .text {
    color: #236dff;
  }
}
</style>
